import { FormattedMessage } from "react-intl";
import { Title } from "./SignupStyles";

function Error() {
  return (
    <div className="600:w-[360px] mx-auto mt-12 flex flex-col pb-12 px-4">
      <Title>
        <FormattedMessage
          id="auth.errorTitle"
          defaultMessage="Something went wrong!"
        />
      </Title>
      <h2>
        <FormattedMessage
          id="auth.errorSubtitle"
          defaultMessage="Our Engineers are on it"
        />
      </h2>
      <a href="/">
        <FormattedMessage id="auth.goHome" defaultMessage="Go Home" />
      </a>
    </div>
  );
}

export default Error;
